/**
 * Actions page tab labels and section styling — January meeting UI carryover.
 * Chatbot "Action Required" maps to the Nudge Requests tab (committer questions).
 */
export const ACTIONS_TAB_LABELS = {
  NUDGE_REQUESTS: "Nudge Requests",
  MY_PROMISES: "My Promises",
  RECEIVED_INVITATIONS: "Received Invitations To Make A Promise",
  AWAITING_RESPONSE: "Awaiting Response",
  /** Committer submitted a badge request; waiting for issuer to approve/reject/clarify. */
  AWAITING_BADGE_APPROVAL: "Awaiting Badge Approval",
  /** Same list as WhatsApp/SMS “Action Required” notifications (accept, answer, issue, etc.). */
  NOTIFICATION: "Action Required",
  PROMISES_OWED_TO_ME: "Promises Owed to Me",
  RECEIVED_PROMISE_OFFERS: "Received Promise Offers",
  BADGE_REQUESTS: "Badge Requests",
} as const;

/** My Commitments (orange): nudge questions first, then promises, invitations, awaiting, notifications. */
export const MY_COMMITMENTS_TAB_ORDER: readonly string[] = [
  ACTIONS_TAB_LABELS.NUDGE_REQUESTS,
  ACTIONS_TAB_LABELS.MY_PROMISES,
  ACTIONS_TAB_LABELS.AWAITING_BADGE_APPROVAL,
  ACTIONS_TAB_LABELS.RECEIVED_INVITATIONS,
  ACTIONS_TAB_LABELS.AWAITING_RESPONSE,
  ACTIONS_TAB_LABELS.NOTIFICATION,
];

/** Others' Commitments (blue): owed, offers, awaiting, badge requests, notifications. */
export const OTHERS_COMMITMENTS_TAB_ORDER: readonly string[] = [
  ACTIONS_TAB_LABELS.PROMISES_OWED_TO_ME,
  ACTIONS_TAB_LABELS.RECEIVED_PROMISE_OFFERS,
  ACTIONS_TAB_LABELS.AWAITING_RESPONSE,
  ACTIONS_TAB_LABELS.BADGE_REQUESTS,
  ACTIONS_TAB_LABELS.NOTIFICATION,
];

/** FAQ 4.4 — orange = my commitments, blue = promises owed to me. */
export const ACTIONS_SECTION_COLORS = {
  myCommitments: "#CC5500",
  othersCommitments: "#1976d2",
  myItemAccent: "#ff7043",
  othersItemAccent: "#1976d2",
  classicMyAccordion: "#ff7f41",
  classicOthersAccordion: "#004a97",
} as const;

export function isNudgeRequestsTabLabel(label: string | undefined): boolean {
  return label === ACTIONS_TAB_LABELS.NUDGE_REQUESTS;
}

export function isActionRequiredTabLabel(label: string | undefined): boolean {
  return label === ACTIONS_TAB_LABELS.NOTIFICATION;
}

export function isMyAwaitingBadgeApprovalTabLabel(
  label: string | undefined
): boolean {
  return label === ACTIONS_TAB_LABELS.AWAITING_BADGE_APPROVAL;
}
